<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		(downloadLastSynthesisEvent)="downloadLastSynthesis()"
		[isDownloadable]="isDownloadable"
		(importingEvent)="uploader.click()"
		[isExportable]="isExportable"
		(exportingEvent)="exportBonCommandes()"
	></app-nav-gestion-donnees>
	

	<input hidden type="file" #uploader (change)="importBonCommandes($event)" />

	<div class="row my-3">
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="pageHasChanged($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
		</div>
		<div class="row">
			<div class="col-2 ms-lg-auto">
				<!-- <div class="dropdown" *ngIf="true">
					<a
						class="btn btn-secondary dropdown-toggle"
						profile="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtres
					</a>
				</div> -->
			</div>

			<div class="col-lg-4 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="marché, lot"
						[(ngModel)]="searchedInput"
					/>
				</div>
			</div>
		</div>
		<div *ngIf="!isMobile" class="row mt-3">
			<div class="col-1">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('lastName')"
					>Marché
				</span>
			</div>
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('lot')"
					>N° commande
				</span>
			</div>
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('description')"
					>Description
				</span>
			</div>
			<div class="col-1">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('dateDebut')"
					>Date de début
				</span>
			</div>
			<div class="col-1">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('dateFin')"
					>Date de fin
				</span>
			</div>
			<div class="col-1">
				<span class="hand-cursor fw-bold limitLineSpan"
					>Service
				</span>
			</div>
			<div class="col-1">
				<span class="hand-cursor fw-bold limitLineSpan"
					>Région
				</span>
			</div>
			<div class="col-2">
				<span class="hand-cursor fw-bold limitLineSpan" (click)="sortChange('adjudicateur')"
					>Adjudicateur
				</span>
			</div>
			<div class="col-1">
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let bonCommande of bonCommandes
						| filterBonCommandeByNumero: searchedInput
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage,
									totalItems: totalItems
							  }
						| orderBy : sortType : sortOrder
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-lg-1 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Marché :</span>
					{{ bonCommande?.marche}}
				</span>
				<span class="col-lg-2 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Commande :</span>
					{{ bonCommande?.commande}}
				</span>
				<span class="col-lg-2 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Description :</span>
					{{ bonCommande?.description}}
				</span>
				<span class="col-lg-1 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Date de fin :</span>
					{{ bonCommande.dateDebut | date : 'dd/MM/yyyy' }}
				</span>
				<span class="col-lg-1 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Date de fin :</span>
					{{ bonCommande.dateFin | date : 'dd/MM/yyyy' }}
				</span>
				<span class="col-lg-1 col-12 limitLineSpan">
					<span
							*ngFor="let exp of bonCommande.services; let ilast = last"
							class="me-1"
						>
							{{ exp && ' ' + exp.service.name }}{{ exp && (ilast ? '' : ',') }}
						</span>
				</span>
				<span class="col-lg-1 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Région :</span>
					{{ bonCommande.region?.name}}
				</span>
				<span class="col-lg-2 col-12 limitLineSpan">
					<span *ngIf="isMobile" class="fw-bold">Adjudicateur :</span>
					{{ bonCommande.adjudicateur }}
				</span>
				<span class="col-lg-1 col-12 limitLineSpan">
					<i
							[routerLink]="['/gestion/bonCommande', bonCommande.id]"
							profile="button"
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
					></i>
				</span>
			</div>
		</div>
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="pageHasChanged($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
		</div>
	</div>
</div>
